export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/template.80837556.svg","height":53,"width":52,"blurWidth":0,"blurHeight":0};